export default "__VITE_ASSET__BR$uSkyD__"